

























































import { defineComponent, PropType, toRefs, computed, ref } from '@vue/composition-api';
import { getCountryCodeId } from '@tt4b/ttam-utils';
import { AdgroupFormData, FullNormalFormData, CampaignFormData } from '@tt4b/ttam-enums';
import { useVisible, useAction, useSelectedSpu, useMaxProductsNum, getProductAmount } from './hooks';
import ProductSelectMain from './subcpn/main.vue';

const name = 'ttam-product-select-from-showcase-compose';
export default defineComponent({
  name,
  components: {
    ProductSelectMain,
  },
  props: {
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData>,
      required: true,
    },
    isRtl: {
      type: Boolean,
      default: false,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { adgroupData, creativeData, campaignData, visible, isRtl } =
      toRefs<{
        adgroupData: AdgroupFormData;
        campaignData: CampaignFormData;
        creativeData: FullNormalFormData;
        visible: boolean;
        isRtl: boolean;
      }>(props);
    // 显示1p的样式，所以这个值还是需要
    const isEcomShop = computed(() => true);
    const shopInfo = ref({});

    const identity = computed(() => ({
      identityId: creativeData.value.identityId,
      identityType: creativeData.value.identityType,
    }));

    const location = computed(() => getCountryCodeId(adgroupData.value.particleLocations));

    const spuDetailList = computed(() => creativeData.value.spuDetailList);
    const { selectedSpuList, resetSelected } = useSelectedSpu({
      spuDetailList,
    });

    const { spuListAmount } = getProductAmount({
      adgroupData,
      campaignData,
      identity,
      location,
      shopInfo,
    });

    const { maxProductsNum: selectNumLimit } = useMaxProductsNum({
      adgroupData,
      campaignData,
      isSingleSelect: ref(false),
    });

    const { slipVisible, slideTransition } = useVisible({
      visible,
      isRtl,
      emit,
      resetSelected,
    });

    const { back, confirm } = useAction({
      selectedSpuList,
      emit,
      slipVisible,
    });

    return {
      shopInfo,
      isEcomShop,
      name,
      identity,
      location,
      selectNumLimit,
      slipVisible,
      slideTransition,
      selectedSpuList,
      back,
      confirm,
      spuListAmount,
    };
  },
});
